import React from "react";
import { CheckCircle } from "lucide-react";

const MetierAdvantages = () => {
  const economicAdvantages = [
    "Réduction des coûts de gestion des déchets",
    "Valorisation des matières recyclables",
    "Optimisation de la logistique",
    "Accompagnement administratif inclus"
  ];

  const environmentalAdvantages = [
    "85% de taux de valorisation",
    "Réduction des émissions de CO₂",
    "Préservation des ressources naturelles",
    "Contribution à l'économie circulaire"
  ];

  return (
    <section className="mb-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
          <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-gray">
            Avantages économiques
          </h2>
          <ul className="space-y-4">
            {economicAdvantages.map((advantage, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">{advantage}</span>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="bg-gradient-to-br from-fabre-lightgreen to-white rounded-3xl shadow-xl p-8 border border-fabre-green/20">
          <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-gray">
            Impact environnemental
          </h2>
          <ul className="space-y-4">
            {environmentalAdvantages.map((advantage, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">{advantage}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MetierAdvantages;